export default __webpack_public_path__ + "static/media/icn-special.d6bb0445.svg";